import React from "react";
import { NavBar } from "../../common/NavBar";
import { usePatrolsStore } from "./patrolsStore/patrolsStore";
import { ParentGroupsDropDownPatrols } from "./ParentGroupDropDownPatrols";
import { SiteDropDownPatrols } from "./SiteDropDownPatrols";
import { StartDateDropDownPatrols } from "./StartDateDropDownPatrols";
import { EndDateDropDownPatrols } from "./EndDateDropDownPatrols";
import { ApplyFiltersButtonPatrols } from "./ApplyFiltersButtonPatrols";
import { PatrolsTable } from "./PatrolsTable";
import { PatrolDialog } from "./PatrolDialog";
import { useFeatureFlag } from "../../../hooks/useFeatureFlag";
import BackdropLoadingScreen from "../../common/BackdropLoadingScreen";

export const Patrols = ({
  navBarCollapsed,
  setNavBarCollapsed,
}: {
  navBarCollapsed: any;
  setNavBarCollapsed: any;
}) => {
  const {
    resetStatePatrols,
    patrolDialogOpen,
    patrolsHistoryLoading,
    filtersAppliedPatrols,
  } = usePatrolsStore();

  // Reset all patrol state when navigating away from the Patrols page
  React.useEffect(() => {
    return () => {
      resetStatePatrols();
    };
  }, [resetStatePatrols]);

  const { flags } = useFeatureFlag();
  const showPatrolsPage = flags.showPatrolsPage;

  if (showPatrolsPage) {
    return (
      <div>
        <BackdropLoadingScreen openState={patrolsHistoryLoading} />
        {patrolDialogOpen && <PatrolDialog />}
        <div className="bg-actuate-grey absolute w-screen h-screen overflow-scroll">
          <div
            className={
              !navBarCollapsed
                ? "font-mulish w-full min-w-[1200px]"
                : "font-mulish w-full min-w-[1200px]"
            }
          >
            <div className={!navBarCollapsed ? "ml-[150px]" : "ml-[75px]"}>
              <div className="bg-white p-4 w-full min-w-fit h-full flex gap-4">
                <ParentGroupsDropDownPatrols
                  navBarCollapsed={navBarCollapsed}
                />
                <SiteDropDownPatrols navBarCollapsed={navBarCollapsed} />
                <StartDateDropDownPatrols />
                <EndDateDropDownPatrols />
                <ApplyFiltersButtonPatrols />
              </div>
              <div className="mt-[20px]">
                {filtersAppliedPatrols ? (
                  <PatrolsTable />
                ) : (
                  <div className="relative top-[200px] text-center">
                    <p className="font-mulish text-[22px]">
                      Please Apply Filters to View Patrols.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="justify-start">
          <NavBar
            navBarCollapsed={navBarCollapsed}
            setNavBarCollapsed={setNavBarCollapsed}
            props={{}}
          />
        </div>
      </div>
    );
  } else if (!showPatrolsPage) {
    return (
      <div>
        <div className="bg-actuate-grey absolute w-screen h-screen overflow-scroll">
          <p className="font-mulish pt-[200px] text-[24px] text-actuate-blue text-center">
            Patrols page coming soon
          </p>
        </div>
        <div className="justify-start">
          <NavBar
            navBarCollapsed={navBarCollapsed}
            setNavBarCollapsed={setNavBarCollapsed}
            props={{}}
          />
        </div>
      </div>
    );
  }

  // Return null or default content when feature flag is false
  return null;
};
